module.exports = __webpack_public_path__ + "img/Check3.1a7dfe81.png";